var map = {
	"./camp.png": 1979,
	"./circle.svg": 1738,
	"./creative.png": 1980,
	"./frontend.png": 1981,
	"./gamedesign.png": 1982,
	"./graphicdesign.png": 1983,
	"./junior.png": 1984,
	"./math-3-4.png": 1985,
	"./math-5-6.png": 1986,
	"./pc.png": 1987,
	"./pytpro-nosnake.png": 1988,
	"./pytpro.png": 1989,
	"./pytstart-nosnake.png": 1990,
	"./pytstart.png": 1991,
	"./quadrangle.svg": 1736,
	"./unity.png": 1992,
	"./videocontent.png": 1993,
	"./websites.png": 1994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1737;